import { AgentStates } from 'types';
import { unitOfTime } from 'moment/moment';
import USDT from 'assets/crypto/usdt.svg';
import USDC0 from 'assets/crypto/USDT0.png';
import USDC from 'assets/crypto/usdc.svg';
import BTC from 'assets/crypto/btc.svg';
import HYPE from 'assets/crypto/hype.svg';
import FEUSD from 'assets/crypto/usde.png';
import { RewardStatus } from 'types/claim';
import { AccountType, TOKEN_NAME } from 'types/distribution';

export const CONSTANT = {
	testNet: 'testnet',
};

export const DATE_TIME_FORMAT = 'DD MMM YYYY hh:mm A';

export const TEST_NET_URL = 'https://testnet.rndm.io?network=movement_porto';

export const APTOS_CONFIG = {
	id: '177',
	rpcUrl: 'https://aptos.testnet.porto.movementlabs.xyz/v1',
	name: 'testnet',
};
export const MOVE_VALUE = 100000000;

export const AGENT = 'Atlas';

export const AGENT_MESSAGE: { [key in AgentStates]: string } = {
	created: 'Agent successfully created. Now start the Agent.',
	started: 'Agent successfully started',
	'stop-requested': 'Agent stop request successfully added',
	stopped: 'Agent successfully stopped',
};

export const THEME_COLOR = '#ffffff99'; //'#d6e3cf';

export type LockTimeType = {
	duration: number;
	difference: unitOfTime.Diff;
};

export const DEPOSIT_LOCK_TIME: LockTimeType = {
	duration: 1,
	difference: 'seconds',
};

export const WITHDRAW_LOCK_TIME: LockTimeType = {
	duration: 7,
	difference: 'days',
};
export const CLAIM_REWARD_LOCK_TIME: LockTimeType = {
	duration: 100,
	difference: 'seconds',
};

export const TOKEN: Record<TOKEN_NAME, { name: string; url: string }> = {
	USDT: {
		name: 'USDT',
		url: USDT,
	},
	USDC: {
		name: 'USDC',
		url: USDC,
	},
	USDT0: {
		name: 'USDC0',
		url: USDC0,
	},
	BTC: {
		name: 'BTC',
		url: BTC,
	},
	HYPE: {
		name: 'HYPE',
		url: HYPE,
	},
	feUSD: {
		name: 'feUSD',
		url: FEUSD,
	},
};

export const BLANK_ACCOUNT: AccountType = {
	points: {
		amount: 0,
		lifetimePoints: 0,
	},
	address: '',
	contract: '',
	tokens: [
		{
			tokenName: 'USDT0',
			tokenAddress: 'usdc-address',
			amount: 0,
			lifetimePNL: 0,
		},
	],
	id: '682103f0aa3a2c1781a944f6',
};

export const WITHDRAW_ADDRESS = '0xBe7f8Ff5CBCedFDBBBBbd0b268a2e99D44fD500a';

export const REWARD_COLOR: Record<RewardStatus, string> = {
	registered: '#275FF1',
	processing: '#FABD10',
	processed: '#1BAA75',
	rejected: '#FF7022',
};
